<template>
  <div>
    <Toast position="top-right" />

    <div class="card">
      <div class="card-body p-0 py-4">
        <div class="aut-area-exibir">
          <div class="configuracao-menu-container">
            <b-tabs>
              <b-tab
                v-for="canal in canais_disponiveis"
                :key="canal.value"
                :title="canal.text"
                class="p-4"
              >
                <div
                  class="header-menus-container"
                  :key="'config-' + canal.value + '-' + chave"
                >
                  <h3>
                    Configurações do Menu -
                    <span style="color: #ffa800">{{ canal.text }}</span>
                  </h3>
                  <div class="botoes-container">
                    <template v-if="possuiConfiguracao(canal.value)">
                      <b-button
                        variant="success mr-2"
                        @click="salvarConfiguracaoMenu"
                      >
                        Salvar Alterações
                      </b-button>
                      <b-button
                        class="btn-danger"
                        variant="primary"
                        @click="descartarAlteracoes"
                        >Descartar
                      </b-button>
                    </template>
                    <template v-else>
                      <b-button
                        variant="success mr-2"
                        @click="criarConfiguracaoPadrao"
                      >
                        Criar Configuração Própria
                      </b-button>
                    </template>
                  </div>
                </div>

                <template v-if="!possuiConfiguracao(canal.value)">
                  <b-alert
                    :show="!possuiConfiguracao(canal.value)"
                    variant="warning"
                    class="text-dark"
                  >
                    Essa conta <b>NÃO POSSUI</b> configuração própria.
                    <br />
                    <template v-if="contaPrincipal != null">
                      A configuração atual é a da conta
                      <b>
                        {{ contaPrincipal.con_nome_identificacao }}
                      </b>
                    </template>
                  </b-alert>
                </template>

                <div
                  :class="!menu[canal.value].cmc_ativo ? 'classe1' : ''"
                  v-if="possuiConfiguracao(canal.value)"
                  :key="'div-body-' + canal.value + '-' + chave"
                >
                  <div class="form-group w-100">
                    <SelectButton
                      v-model="menu[canal.value].cmc_ativo"
                      :options="arrAtivo"
                      optionLabel="text"
                      optionValue="value"
                      :class="
                        menu[canal.value].cmc_ativo
                          ? 'select-button-ativado'
                          : 'select-button-inativado'
                      "
                      @input="ativarDesativar(canal.value)"
                    />
                  </div>

                  <h6>Mensagens Padrão</h6>
                  <div class="flexer-container">
                    <div class="form-group w-100">
                      <label for="titulo">Início de Atendimento</label>
                      <b-form-textarea
                        type="text"
                        :disabled="!desativarCanal[canal.value]"
                        class="form-control"
                        id="titulo"
                        placeholder="Olá! Eu sou um assistente virtual, digite o número correspondente ao serviço que você precisa de ajuda:"
                        v-model="menu[canal.value].cmc_msg_menu"
                        rows="5"
                      />
                    </div>
                    <div class="form-group w-100">
                      <label for="ordem">
                        Fim de Atendimento
                        <span class="text-danger">*</span>
                      </label>
                      <b-form-textarea
                        type="text"
                        :disabled="!desativarCanal[canal.value]"
                        class="form-control"
                        id="cmc_msg_fim_atendimento"
                        placeholder="Fim de atendimento, obrigado pela preferência..."
                        v-model="menu[canal.value].cmc_msg_fim_atendimento"
                        rows="5"
                      />
                    </div>
                    <div class="form-group w-100">
                      <label for="ordem">
                        Redirecionar para Atende
                        <span class="text-danger">*</span>
                      </label>
                      <b-form-textarea
                        type="text"
                        :disabled="!desativarCanal[canal.value]"
                        class="form-control"
                        id="cmc_msg_fim_atendimento"
                        placeholder="Só um momento, estou transferindo seu contato para um de nossos atendentes."
                        v-model="msgRedirecionar"
                        rows="5"
                      />
                    </div>
                  </div>

                  <div class="flexer-container">
                    <div class="form-group w-100">
                      <label for="ordem">
                        Resposta Inválida
                        <span class="text-danger">*</span>
                      </label>
                      <b-form-textarea
                        type="text"
                        :disabled="!desativarCanal[canal.value]"
                        class="form-control"
                        id="ordem"
                        placeholder="Eu não estou conseguindo entender sobre o quê você gostaria de conversar 🙁. Para ver todos os serviços oferecidos, digite a palavra *menu*"
                        v-model="menu[canal.value].cmc_msg_item_invalido"
                        rows="5"
                      />
                    </div>
                    <div class="form-group w-100">
                      <label for="ordem">
                        Erro ao Realizar Consultas
                        <span class="text-danger">*</span>
                      </label>
                      <b-form-textarea
                        type="text"
                        :disabled="!desativarCanal[canal.value]"
                        class="form-control"
                        id="cmc_msg_fim_atendimento"
                        placeholder="Erro interno, tente novamente."
                        v-model="menu[canal.value].cmc_msg_erro"
                        rows="5"
                      />
                    </div>
                  </div>
                  <hr />

                  <h6>Paginação de Listas</h6>
                  <div class="flexer-container">
                    <div
                      class="form-group w-100"
                      v-b-tooltip.hover
                      title="Paginar quando necessário. Caso envie uma lista com mais de 10 itens"
                    >
                      <label>
                        Habilitar Paginação
                        <span class="text-danger">*</span>
                      </label>

                      {{ menu[canal.value].customizacao }}
                      <SelectButton
                        v-model="menu[canal.value].cmc_paginacao_ativo"
                        :disabled="!desativarCanal[canal.value]"
                        :options="arrAtivo"
                        optionLabel="text"
                        optionValue="value"
                        :class="
                          menu[canal.value].cmc_paginacao_ativo
                            ? 'select-button-ativado'
                            : 'select-button-inativado'
                        "
                      />
                    </div>
                    <div
                      class="form-group w-100"
                      v-b-tooltip.hover
                      title="Texto exibido no botão para voltar aos resultados anteriores"
                    >
                      <label for="ordem">
                        Página Anterior
                        <span class="text-danger">*</span>
                      </label>
                      <b-form-input
                        type="text"
                        :disabled="!desativarCanal[canal.value]"
                        class="form-control"
                        v-model="
                          menu[canal.value].cmc_paginacao_ativo_txt_btn_voltar
                        "
                      />
                    </div>
                    <div
                      class="form-group w-100"
                      v-b-tooltip.hover
                      title="Texto exibido no botão para ir aos próximos resultados"
                    >
                      <label for="ordem">
                        Próxima Página
                        <span class="text-danger">*</span>
                      </label>
                      <b-form-input
                        type="text"
                        :disabled="!desativarCanal[canal.value]"
                        class="form-control"
                        v-model="
                          menu[canal.value].cmc_paginacao_ativo_txt_btn_proximo
                        "
                      />
                    </div>
                  </div>
                  <hr />

                  <h6>Configurações Gerais</h6>
                  <div class="flexer-container w-75">
                    <div class="form-group w-100">
                      <label for="ordem">
                        N° Max de Itens por Consulta
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        :disabled="!desativarCanal[canal.value]"
                        class="form-control"
                        id="cmc_qtd_max_resultados"
                        placeholder="10"
                        v-model="menu[canal.value].cmc_qtd_max_resultados"
                        min="1"
                      />
                    </div>
                    <div class="form-group w-100">
                      <label for="ativo">
                        Replicar Conversa em Tempo Real
                        <span class="text-danger">*</span>
                      </label>
                      <SelectButton
                        v-model="
                          menu[canal.value].bool_replicar_conversa_tempo_real
                        "
                        :disabled="!desativarCanal[canal.value]"
                        :options="arrAtivo"
                        optionLabel="text"
                        optionValue="value"
                        :class="
                          menu[canal.value].bool_replicar_conversa_tempo_real
                            ? 'select-button-ativado'
                            : 'select-button-inativado'
                        "
                      />
                    </div>

                    <div
                      class="form-group w-100"
                      v-if="verificarRecursoAtivo('IA_BOT')"
                    >
                      <label for="ativo">
                        Letícia IA
                        <span class="text-danger">*</span>
                      </label>
                      <SelectButton
                        v-model="menu[canal.value].cmc_inteligencia_artificial"
                        :disabled="!desativarCanal[canal.value]"
                        :options="arrAtivo"
                        optionLabel="text"
                        optionValue="value"
                        :class="
                          menu[canal.value].cmc_inteligencia_artificial
                            ? 'select-button-ativado'
                            : 'select-button-inativado'
                        "
                      />
                    </div>
                  </div>
                  <hr />

                  <h6>Transcição Multimídia (IA)</h6>
                  <div class="w-50 flexer-container">
                    <div
                      class="form-group w-100"
                      v-b-tooltip.hover
                      title="Caso o usuário envie uma imagem em um estágio de mensagem a inteligência artificial irá interpreta-la e transformar em texto."
                    >
                      <label for="ativo">
                        Interpretar Imagens
                        <span class="text-danger">*</span>
                      </label>
                      <SelectButton
                        v-model="
                          menu[canal.value].cmc_inteligencia_artificial_imagem
                        "
                        :disabled="!desativarCanal[canal.value]"
                        :options="arrAtivo"
                        optionLabel="text"
                        optionValue="value"
                        :class="
                          menu[canal.value].cmc_inteligencia_artificial_imagem
                            ? 'select-button-ativado'
                            : 'select-button-inativado'
                        "
                      />
                    </div>
                    <div
                      class="form-group w-100"
                      v-b-tooltip.hover
                      title="Caso o usuário envie um áudio a inteligência artificial irá interpreta-lo e transformar em texto."
                    >
                      <label for="ativo">
                        Interpretar Áudios
                        <span class="text-danger">*</span>
                      </label>
                      <SelectButton
                        v-model="
                          menu[canal.value].cmc_inteligencia_artificial_audio
                        "
                        :disabled="!desativarCanal[canal.value]"
                        :options="arrAtivo"
                        optionLabel="text"
                        optionValue="value"
                        :class="
                          menu[canal.value].cmc_inteligencia_artificial_audio
                            ? 'select-button-ativado'
                            : 'select-button-inativado'
                        "
                      />
                    </div>
                  </div>
                  <hr />

                  <h6>Ação Padrão</h6>
                  <div class="w-100 flexer-container">
                    <div class="form-group w-100">
                      <label for="ativo">Pré-Fluxo</label>
                      <div
                        class="w-100 d-flex align-items-center justify-content-between"
                      >
                        <pv-dropdown
                          class="form-control w-100"
                          :disabled="!desativarCanal[canal.value]"
                          optionLabel="text"
                          optionValue="value"
                          emptyFilterMessage="Sem Pré-fluxo"
                          :filter="true"
                          :options="acao_inatividade_options"
                          placeholder="Nenhum selecionado"
                          v-model="menu[canal.value].cmc_prefluxo"
                        ></pv-dropdown>
                        <i
                          v-if="menu[canal.value].cmc_prefluxo"
                          class="fas fa-external-link-alt ml-2 d-flex align-items-center justify-content-center"
                          style="
                            font-size: 18px;
                            cursor: pointer;
                            border: 1px solid #e4e6ef;
                            padding: 4px;
                            border-radius: 4px;
                            width: 38px;
                            height: 38px;
                          "
                          v-b-tooltip.hover
                          title="Mostrar fluxo em outra janela"
                          @click="
                            abrirFluxoEmNovaAba(menu[canal.value].cmc_prefluxo)
                          "
                        ></i>
                      </div>
                    </div>
                    <div class="form-group w-100">
                      <label for="ativo">Ação Fora do Expediente</label>
                      <div
                        class="w-100 d-flex align-items-center justify-content-between"
                      >
                        <pv-dropdown
                          class="form-control w-100"
                          :disabled="!desativarCanal[canal.value]"
                          optionLabel="text"
                          optionValue="value"
                          emptyFilterMessage="Nenhuma Ação"
                          :filter="true"
                          :options="acao_inatividade_options"
                          placeholder="Nenhum selecionado"
                          v-model="menu[canal.value].cmc_fluxo_fora_expediente"
                        ></pv-dropdown>
                        <i
                          v-if="menu[canal.value].cmc_fluxo_fora_expediente"
                          class="fas fa-external-link-alt ml-2 d-flex align-items-center justify-content-center"
                          style="
                            font-size: 18px;
                            cursor: pointer;
                            border: 1px solid #e4e6ef;
                            padding: 4px;
                            border-radius: 4px;
                            width: 38px;
                            height: 38px;
                          "
                          v-b-tooltip.hover
                          title="Mostrar fluxo em outra janela"
                          @click="
                            abrirFluxoEmNovaAba(
                              menu[canal.value].cmc_fluxo_fora_expediente
                            )
                          "
                        ></i>
                      </div>
                    </div>
                  </div>
                  <hr />

                  <h6>Ação Para Inatividade</h6>
                  <div class="w-75 flexer-container">
                    <div class="form-group w-50">
                      <label for="ativo">
                        Tempo de Inatividade (em minutos)
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        class="form-control"
                        :disabled="!desativarCanal[canal.value]"
                        id="cmc_tempo_inatividade"
                        placeholder="15"
                        v-model="menu[canal.value].cmc_tempo_inatividade"
                        type="number"
                        min="2"
                        @change="
                          verificarTempoInatividade(
                            menu[canal.value].cmc_tempo_inatividade
                          )
                        "
                      />
                    </div>
                    <div class="form-group w-100">
                      <label for="ativo">
                        Ação em Caso de Inatividade
                        <span class="text-danger">*</span>
                      </label>
                      <div
                        class="w-100 d-flex align-items-center justify-content-between"
                      >
                        <pv-dropdown
                          class="form-control w-100"
                          :disabled="!desativarCanal[canal.value]"
                          optionLabel="text"
                          optionValue="value"
                          emptyFilterMessage="Nenhum resultado"
                          :filter="true"
                          :options="acao_inatividade_options"
                          placeholder="Nenhum selecionado"
                          v-model="menu[canal.value].cmc_acao_inatividade"
                        ></pv-dropdown>
                        <i
                          v-if="menu[canal.value].cmc_acao_inatividade"
                          class="fas fa-external-link-alt ml-2 d-flex align-items-center justify-content-center"
                          style="
                            font-size: 18px;
                            cursor: pointer;
                            border: 1px solid #e4e6ef;
                            padding: 4px;
                            border-radius: 4px;
                            width: 38px;
                            height: 38px;
                          "
                          v-b-tooltip.hover
                          title="Mostrar fluxo em outra janela"
                          @click="
                            abrirFluxoEmNovaAba(
                              menu[canal.value].cmc_acao_inatividade
                            )
                          "
                        ></i>
                      </div>
                    </div>
                  </div>
                  <hr />

                  <h6>Tratamento de Erros</h6>
                  <div class="w-75 flexer-container">
                    <div class="form-group w-50">
                      <label for="cmc_qtd_erro_maximo">
                        N° Max de Erros no Menu Principal
                        <span class="text-danger">*</span>
                      </label>
                      <b-form-select
                        :options="qtd_erros_options"
                        :disabled="!desativarCanal[canal.value]"
                        v-model="menu[canal.value].cmc_qtd_erro_maximo"
                        class="col"
                        id="cmc_qtd_erro_maximo"
                      ></b-form-select>
                    </div>
                    <div class="form-group w-100">
                      <label for="ativo">
                        Ação para Máx Erros Excedido
                        <span class="text-danger">*</span>
                      </label>
                      <div
                        class="w-100 d-flex align-items-center justify-content-between"
                      >
                        <pv-dropdown
                          class="w-100"
                          :disabled="!desativarCanal[canal.value]"
                          optionLabel="text"
                          optionValue="value"
                          emptyFilterMessage="Nenhum resultado"
                          :filter="true"
                          :options="acao_inatividade_options"
                          placeholder="Nenhum selecionado"
                          v-model="menu[canal.value].tratamento_erro_fluxo_id"
                        ></pv-dropdown>
                        <i
                          v-if="menu[canal.value].tratamento_erro_fluxo_id"
                          class="fas fa-external-link-alt ml-2 d-flex align-items-center justify-content-center"
                          style="
                            font-size: 18px;
                            cursor: pointer;
                            border: 1px solid #e4e6ef;
                            padding: 4px;
                            border-radius: 4px;
                            width: 38px;
                            height: 38px;
                          "
                          v-b-tooltip.hover
                          title="Mostrar fluxo em outra janela"
                          @click="
                            abrirFluxoEmNovaAba(
                              menu[canal.value].tratamento_erro_fluxo_id
                            )
                          "
                        ></i>
                      </div>
                    </div>
                  </div>
                  <hr />

                  <h6>Gerenciamento de Contatos</h6>
                  <div class="w-100 flexer-container">
                    <div class="form-group w-50">
                      <label for="ativo">
                        Responder apenas a (ou a todos, se nenhum for
                        especificado)
                      </label>

                      <Chips
                        v-model="menu[canal.value].cmc_arr_numeros"
                        :disabled="!desativarCanal[canal.value]"
                        separator=","
                        class="w-100 mt-3"
                      >
                        <template #chip="slotProps">
                          <div class="lista-teste">
                            <i
                              class="pi pi-user-plus"
                              style="font-size: 18px"
                            ></i>
                            <span>{{ slotProps.value }}</span>
                          </div>
                        </template>
                      </Chips>
                      <label style="color: #8b8b8b"
                        >Inserir vírgula para separar</label
                      >
                    </div>

                    <div class="form-group w-50">
                      <label for="ativo"> Não responder a (Bloqueados) </label>

                      <Chips
                        v-model="menu[canal.value].cmc_arr_numeros_ignorar"
                        :disabled="!desativarCanal[canal.value]"
                        separator=","
                        class="w-100 mt-3"
                      >
                        <template #chip="slotProps">
                          <div class="lista-negra">
                            <i
                              class="pi pi-user-minus"
                              style="font-size: 18px"
                            ></i>
                            <span>{{ slotProps.value }}</span>
                          </div>
                        </template>
                      </Chips>
                      <label style="color: #8b8b8b"
                        >Inserir vírgula para separar</label
                      >
                    </div>
                  </div>

                  <template
                    v-if="menu[canal.value].cmc_inteligencia_artificial"
                  >
                    <hr />
                    <h6>Letícia IA - Gerenciamento de Contatos</h6>
                    <div class="w-100 flexer-container">
                      <div class="form-group w-50">
                        <label for="ativo">
                          A IA responde apenas a (ou a todos, se nenhum for
                          especificado)
                        </label>

                        <Chips
                          v-model="menu[canal.value].cmc_numeros_ativos_ia"
                          :disabled="!desativarCanal[canal.value]"
                          separator=","
                          class="w-100 mt-3"
                        >
                          <template #chip="slotProps">
                            <div class="lista-permissao">
                              <i
                                class="pi pi-user-plus"
                                style="font-size: 18px"
                              ></i>
                              <span>{{ slotProps.value }}</span>
                            </div>
                          </template>
                        </Chips>
                        <label style="color: #8b8b8b"
                          >Inserir vírgula para separar</label
                        >
                      </div>
                    </div>
                  </template>
                  <!-- fim bloco -->
                </div>
                <!-- fim div canal -->
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Swal from "sweetalert2";
import Chips from "primevue/chips";
import SelectButton from "primevue/selectbutton";

import ApiService from "@/core/services/api.service";
import API_LINKS from "../automacao/api.links";

export default {
  components: {
    Toast: () => import("primevue/toast"),
    Chips,
    SelectButton
  },
  data() {
    return {
      canais_possiveis: [
        { value: "AGENTE_SITE_WIDGET", text: "Widget" },
        { value: "WHATSAPP_OFICIAL", text: "WhatsApp (Oficial)" },
        { value: "INSTAGRAM", text: "Instagram" }
      ],
      qtd_erros_options: [
        { value: 1, text: "1" },
        { value: 2, text: "2" },
        { value: 3, text: "3" },
        { value: 4, text: "4" },
        { value: 5, text: "5" },
        { value: 10, text: "10" }
      ],
      arrAtivo: [
        { value: true, text: "Ativo" },
        { value: false, text: "Inativo" }
      ],
      recursos: [],
      canais_disponiveis: [{ value: "PRINCIPAL", text: "Principal" }],
      canais_obj_enviar: {
        principal: {},
        whatsapp: {},
        instagram: {},
        agente_site: {}
      },
      menuConfigsIniciais: {},
      acao_inatividade_options: [{ value: null, text: "Nenhuma" }],
      prefluxo_options: [{ value: null, text: "Nenhum pré-fluxo" }],
      menu: {
        PRINCIPAL: {
          cmc_canal: null,
          cmc_msg_menu: "",
          cmc_msg_item_invalido: "",
          cmc_msg_erro: "",
          cmc_msg_fim_atendimento: "",
          cmc_qtd_max_resultados: 20,
          cmc_ativo: true,
          cmc_arr_numeros: [],
          cmc_arr_numeros_ignorar: [],
          cmc_acao_inatividade: null,
          cmc_tempo_inatividade: 15,
          cmc_qtd_erro_maximo: 3,
          tratamento_erro_fluxo_id: null,
          cmc_prefluxo: null,
          cmc_fluxo_fora_expediente: null,
          cmc_msg_erro_redirecionamento: ""
        },
        WHATSAPP_OFICIAL: {
          cmc_canal: "AW",
          cmc_msg_menu: "",
          cmc_msg_item_invalido: "",
          cmc_msg_erro: "",
          cmc_msg_fim_atendimento: "",
          cmc_qtd_max_resultados: 20,
          cmc_ativo: true,
          cmc_arr_numeros: [],
          cmc_arr_numeros_ignorar: [],
          cmc_acao_inatividade: null,
          cmc_tempo_inatividade: 15,
          cmc_qtd_erro_maximo: 3,
          tratamento_erro_fluxo_id: null,
          cmc_prefluxo: null,
          cmc_fluxo_fora_expediente: null,
          cmc_msg_erro_redirecionamento: ""
        },
        INSTAGRAM: {
          cmc_canal: "AI",
          cmc_msg_menu: "",
          cmc_msg_item_invalido: "",
          cmc_msg_erro: "",
          cmc_msg_fim_atendimento: "",
          cmc_qtd_max_resultados: 20,
          cmc_ativo: true,
          cmc_arr_numeros: [],
          cmc_arr_numeros_ignorar: [],
          cmc_acao_inatividade: null,
          cmc_tempo_inatividade: 15,
          cmc_qtd_erro_maximo: 3,
          tratamento_erro_fluxo_id: null,
          cmc_prefluxo: null,
          cmc_fluxo_fora_expediente: null,
          cmc_msg_erro_redirecionamento: ""
        },
        AGENTE_SITE_WIDGET: {
          cmc_canal: "AS",
          cmc_msg_menu: "",
          cmc_msg_item_invalido: "",
          cmc_msg_erro: "",
          cmc_msg_fim_atendimento: "",
          cmc_qtd_max_resultados: 20,
          cmc_ativo: true,
          cmc_arr_numeros: [],
          cmc_arr_numeros_ignorar: [],
          cmc_acao_inatividade: null,
          cmc_tempo_inatividade: 15,
          cmc_qtd_erro_maximo: 3,
          tratamento_erro_fluxo_id: null,
          cmc_prefluxo: null,
          cmc_fluxo_fora_expediente: null,
          cmc_msg_erro_redirecionamento: ""
        }
      },
      canaisOriginais: {},
      chave: 0,
      contaPrincipal: null,
      desativarCanal: {
        PRINCIPAL: false,
        WHATSAPP_OFICIAL: false,
        INSTAGRAM: false,
        AGENTE_SITE_WIDGET: false
      },
      menuCadastrar: {
        menuFluxo: "",
        menuTitulo: "",
        menuOrdem: 1,
        menuAtivo: false
      },
      menusChatbot: [],
      menuConfiguracao: [],
      msgRedirecionar: null,
      porPagina: 10,
      paginaAtual: 1,
      fluxos: [],
      campos: [
        { key: "chatbot_menu_item_id", label: "ID" },
        { key: "cfl_titulo", label: "Nome" },
        { key: "descricao", label: "Descrição" },
        { key: "data_criacao", label: "Data de Criação" },
        { key: "data_atualizacao", label: "Data de Atualização" },
        { key: "acoes", label: "Ações" }
      ]
    };
  },
  methods: {
    possuiConfiguracao(canal) {
      return canal in this.canaisOriginais && this.canaisOriginais[canal] == 1;
    },
    verificarTempoInatividade(tempo_inatividade) {
      if (tempo_inatividade <= 5) {
        this.$toast.add({
          severity: "warn",
          summary: "Atenção",
          detail:
            "Devido a latência de envio e recebimento de mensagens, tempos de timeout abaixo de 5 minutos podem ocasionar comportamento inesperado.",
          life: 5000
        });
      }
    },
    recursosDeCanaisValidos(recursos) {
      this.recursos = recursos;
      const recursos_validos = [];
      recursos.forEach((recurso) => {
        const obj = this.canais_possiveis.find((v) => v.value === recurso);
        if (obj) {
          recursos_validos.push(obj);
        }
      });
      this.canais_disponiveis =
        this.canais_disponiveis.concat(recursos_validos);
    },
    pegarRecursosDaConta() {
      ApiService.get(API_LINKS.recursosAtivos).then((res) => {
        this.recursosDeCanaisValidos(res.data.data.map((v) => v.rec_codigo));
      });
    },
    descartarAlteracoes() {
      if (!this.houveAlgumaMudanca) {
        return;
      }
      Swal.fire({
        title: "Descartar Alterações?",
        text: "Você tem certeza que deseja descartar as alterações?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, descartar!"
      }).then((result) => {
        if (result.value) {
          this.menu = this.menuConfigsIniciais;
        }
      });
    },
    ativarDesativar(canal) {
      this.desativarCanal[canal] = this.menu[canal].cmc_ativo;
    },
    abrirFluxoEmNovaAba(fluxoId) {
      const routeData = this.$router.resolve({
        name: "automacao.fluxo.editar",
        query: {
          fluxo_id: fluxoId
        }
      });
      window.open(routeData.href, "_blank");
    },
    criarConfiguracaoPadrao() {
      Swal.fire({
        title: "Criar Configuração Padrão?",
        text: "Você tem certeza que deseja criar uma configuração padrão?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim!",
        cancelButtonText: "Não!"
      }).then((result) => {
        if (result.value) {
          const payload = {};

          ApiService.post(
            API_LINKS.chatbot_menu_configuracao_padrao,
            payload
          ).then(() => {
            Swal.fire(
              "Salvo!",
              "As alterações foram salvas com sucesso.",
              "success"
            ).then(() => {
              window.location.reload();
            });
          });
        }
      });
    },
    salvarConfiguracaoMenu() {
      Swal.fire({
        title: "Salvar Alterações?",
        text: "Você tem certeza que deseja salvar as alterações?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, salvar!",
        cancelButtonText: "Não, cancelar!"
      }).then((result) => {
        if (result.value) {
          const payload = {
            configuracao: [],
            msgRedirecionar: this.msgRedirecionar
          };

          for (const key in this.menu) {
            if (this.menu.hasOwnProperty(key)) {
              const element = this.menu[key];
              if (element.cmc_tempo_inatividade == null) {
                element.cmc_tempo_inatividade = 15;
              }
              if (element.cmc_tempo_inatividade <= 1) {
                Swal.fire({
                  title: "Erro!",
                  text: "O tempo de mínimo inatividade deve ser maior que 1 minuto.",
                  icon: "error",
                  confirmButtonText: "Ok"
                });
                return;
              }
              if (element.cmc_qtd_erro_maximo == null) {
                element.cmc_qtd_erro_maximo = 3;
              }
              payload.configuracao.push(element);
            }
          }

          ApiService.post(API_LINKS.chatbot_menu_configuracao, payload).then(
            () => {
              Swal.fire(
                "Salvo!",
                "As alterações foram salvas com sucesso.",
                "success"
              );
              this.$emit("menuSalvoComSucesso");
            }
          );
        }
      });
    },
    pegarConfiguracoesMenu() {
      ApiService.get(API_LINKS.chatbot_menu).then((res) => {
        if (res.data?.sucesso === false) {
          Swal.fire({
            title: "Erro!",
            text: res.data.errors,
            icon: "error",
            confirmButtonText: "Ok"
          });
          return;
        }
        const menuConfigs = {};
        res.data.menuConfiguracao.map((config) => {
          // valores default caso não estejam preenchidos
          if (!config.cmc_paginacao_ativo_txt_btn_proximo)
            config.cmc_paginacao_ativo_txt_btn_proximo = "Próxmos Resultados";
          if (!config.cmc_paginacao_ativo_txt_btn_voltar)
            config.cmc_paginacao_ativo_txt_btn_voltar = "Resultados Anteriores";

          if (config.cmc_canal === "AS") {
            menuConfigs.AGENTE_SITE_WIDGET = config;
          } else if (config.cmc_canal === "AW") {
            menuConfigs.WHATSAPP_OFICIAL = config;
          } else if (config.cmc_canal === "AI") {
            menuConfigs.INSTAGRAM = config;
          } else if (config.cmc_canal === null) {
            menuConfigs.PRINCIPAL = config;
          }
        });

        if ("AGENTE_SITE_WIDGET" in menuConfigs) {
          this.menu.AGENTE_SITE_WIDGET = menuConfigs.AGENTE_SITE_WIDGET;
          this.canaisOriginais.AGENTE_SITE_WIDGET = 1;
        }
        if ("WHATSAPP_OFICIAL" in menuConfigs) {
          this.menu.WHATSAPP_OFICIAL = menuConfigs.WHATSAPP_OFICIAL;
          this.canaisOriginais.WHATSAPP_OFICIAL = 1;
        }
        if ("INSTAGRAM" in menuConfigs) {
          this.menu.INSTAGRAM = menuConfigs.INSTAGRAM;
          this.canaisOriginais.INSTAGRAM = 1;
        }
        if ("PRINCIPAL" in menuConfigs) {
          this.menu.PRINCIPAL = menuConfigs.PRINCIPAL;
          this.canaisOriginais.PRINCIPAL = 1;
        }
        this.chave += 1;
        // this.menu = menuConfigs;
        this.contaPrincipal = res.data.contaPrincipal;
        this.menuConfigsIniciais = JSON.parse(JSON.stringify(this.menu));
        this.msgRedirecionar = res.data.msgRedirecionar;

        for (const key in this.desativarCanal) {
          if (key in this.menu) {
            this.desativarCanal[key] = this.menu[key].cmc_ativo;
          }
        }
      });
    },
    pegarFluxos() {
      ApiService.get(API_LINKS.chatbot_listar_fluxos).then((res) => {
        this.fluxos = res.data.fluxos.map((fluxo) => {
          return {
            ...fluxo,
            value: fluxo.chatbot_fluxo_id,
            text: fluxo.cfl_titulo
          };
        });
        this.acao_inatividade_options = this.acao_inatividade_options.concat(
          this.fluxos
        );
        this.prefluxo_options = this.prefluxo_options.concat(this.fluxos);
      });
    },
    verificarRecursoAtivo(recurso) {
      return this.recursos.includes(recurso);
    }
  },

  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Chatbot"
      },
      {
        title: "Opções",
        route: "/painel/chatbot/opcoes"
      }
    ]);

    this.pegarRecursosDaConta();
    this.pegarFluxos();
    this.pegarConfiguracoesMenu();
  },
  computed: {
    houveAlgumaMudanca() {
      return (
        JSON.stringify(this.menu) != JSON.stringify(this.menuConfigsIniciais)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300&display=swap");

.b-button-custom {
  width: 142px;
}

.aut-body {
  border-radius: 5px;
  background-color: #fff;
}

.aut-area-exibir {
  display: flex;
  height: 100%;
  width: 100%;
}

.aut-header {
  height: 70px;
  width: 100%;
}

.aut-camp-area {
  width: 100%;
  min-height: 500px;
}

.container-dashboard {
  border-radius: 15px;
  background-color: #fff;
  padding: 20px 10px 20px 10px;
  margin-bottom: 15px;
}

.campo-estatistica {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.dropdown-form {
  padding: 3px 0px;
  width: 170px;
  height: 45px;
}

.dropdown-form:hover {
  background-color: rgb(247, 247, 247);
}

.button-container {
  border: 1px solid #e4e6ef;
  outline: none;
  color: #e3e4ed;
  background-color: transparent;
  border-radius: 0.42rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 38px;
}
.button-container.btn i {
  padding: 0 !important;
}

::v-deep .p-chips .p-chips-multiple-container {
  width: 100% !important;
}
::v-deep .p-chips-multiple-container {
  flex-wrap: wrap !important;
  gap: 0.5rem !important;
}
/*
::v-deep .p-selectbutton .p-button {
  background: #c4c4c4 !important;
  border-color: #c4c4c4 !important;

  &.p-highlight {
    background: #ffc107 !important;
    border-color: #ffc107 !important;
    color: #212121 !important;
  }
}
*/
::v-deep .select-button-ativado .p-button {
  background: #ffffff !important;
  border-color: #ced4da !important;
  color: #000000 !important;

  &.p-highlight {
    background: #1bc5bd !important;
    border-color: #1bc5bd !important;
    color: #ffffff !important;
  }
}

::v-deep .select-button-inativado .p-button {
  background: #ffffff !important;
  border-color: #ced4da !important;
  color: #000000 !important;

  &.p-highlight {
    background: #ee2d41 !important;
    border-color: #ee2d41 !important;
    color: #ffffff !important;
  }
}

.configuracao-menu-container {
  width: 100%;

  .header-menus-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    h3 {
      margin: 0;
    }
    .botoes-container {
      display: flex;
      justify-content: space-between;
    }
  }

  .flexer-container {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    min-height: 100% !important;
  }

  .flexer-col {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100% !important;

    > .form-group:first-child {
      margin-bottom: 0 !important;
    }
  }

  .lista-teste span {
    color: rgb(75, 112, 190);
    font-weight: bold;
  }
  .lista-teste i {
    color: blue;
    margin-right: 10px;
  }

  .lista-negra span {
    color: rgb(226, 77, 77);
    font-weight: bold;
  }
  .lista-negra i {
    color: red;
    margin-right: 10px;
  }

  .lista-permissao span {
    color: #148b86;
    font-weight: bold;
  }
  .lista-permissao i {
    color: #148b86;
    margin-right: 10px;
  }
  hr {
    margin-left: 1%;
    width: 98%;
    margin-bottom: 30px;
    margin-top: -10px;
  }
}
</style>
